function convertToHTML(text) {
    // 使用正则表达式替换文本中的制表符、回车符和换行符
    return text
        .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')  // 将制表符替换为 4 个空格
        .replace(/\r\n/g, '<br>');             // 将回车符和换行符替换为 <br> 标签
}

function containsHtmlTags(str) {
    const htmlMap = ['#text', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'DIV', 'SPAN', 'BR', 'UL', 'OL', 'P', 'A', 'IMG', 'AUDIO', 'VIDEO', 'BUTTON', 'CANVAS', 'CODE', '#comment', 'EM', 'FOOTER', 'IFRAME', 'HR', 'INPUT', 'LABEL', 'NAV', 'I', 'LINK', 'MAIN', 'OPTION', 'CENTER', 'PRE', 'SCRIPT', 'SELECT', 'STRONG', 'STYLE', 'TABLE', 'TEXTAREA'];

    const parser = new DOMParser();
    const doc = parser.parseFromString(str, "text/html");
    // console.log(
    //   Array.from(doc.body.childNodes).map((node) => `${node.nodeName}`)
    // );
    // // 如果解析出的文档中有元素节点，则说明字符串中包含 HTML 标签
    return Array.from(doc.body.childNodes).some((node) => {
        console.log(node, node.nodeType, Node.ELEMENT_NODE, "hello", node.nodeType === Node.ELEMENT_NODE && htmlMap.includes(node.nodeName));
        return (
            node.nodeType === Node.ELEMENT_NODE && htmlMap.includes(node.nodeName)
        );
    });
}

// url 超链接超链接
function convertLinksToHTML(input) {
    if (!input) return input;

    const str = String(input);
    const urlRegex = /(https?:\/\/[^\s<>"]+)/g;

    // Fast path: plain text (no tags). Safe to do direct replace.
    if (str.indexOf('<') === -1) {
        return str.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
    }

    // HTML path: only linkify text nodes. Never touch URLs inside attributes like <img src="...">.
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
        const textNode = walker.currentNode;
        if (!textNode || !textNode.nodeValue) continue;

        const parentEl = textNode.parentElement;
        const parentName = (parentEl?.nodeName || '').toUpperCase();
        if (['A', 'SCRIPT', 'STYLE', 'TEXTAREA'].includes(parentName)) continue;

        const text = textNode.nodeValue;
        if (!urlRegex.test(text)) {
            urlRegex.lastIndex = 0;
            continue;
        }
        urlRegex.lastIndex = 0;

        const frag = doc.createDocumentFragment();
        let lastIndex = 0;
        let match;

        while ((match = urlRegex.exec(text)) !== null) {
            const url = match[0];
            const start = match.index;

            if (start > lastIndex) {
                frag.appendChild(doc.createTextNode(text.slice(lastIndex, start)));
            }

            const a = doc.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.appendChild(doc.createTextNode(url));
            frag.appendChild(a);

            lastIndex = start + url.length;
        }

        if (lastIndex < text.length) {
            frag.appendChild(doc.createTextNode(text.slice(lastIndex)));
        }

        textNode.parentNode.replaceChild(frag, textNode);
        urlRegex.lastIndex = 0;
    }

    return doc.body.innerHTML;
}

/**
 * 匹配所有img 并添加 error 事件
 * @param htmlString
 * @returns {*}
 */
function addImgOnErrorAttribute(htmlString) {
    if (!htmlString) {
        return
    }
    // 正则表达式匹配所有的 img 标签
    const imgTagRegex = /<img\s+([^>]*\s)?src\s*=\s*['"][^'"]*['"]([^>]*)>/gi;

    // 回调函数用于处理每个匹配的 img 标签
    return htmlString?.replace(imgTagRegex, (match, p1, p2) => {
        // 检查 img 标签是否已经有 onerror 属性
        if (/onerror\s*=\s*['"][^'"]*['"]/i.test(match)) {
            return match; // 已经有 onerror 属性，返回原始标签
        }
        // 插入 onerror 属性
        return match.replace(
            /<img\s+/i,
            "<img onerror=\"errorImage(this)\" "
        );
    });
}

/**
 * 为 iframe 文档绑定链接/按钮点击拦截，使邮件正文内的链接在新标签页打开。
 * srcdoc iframe 的链接默认会尝试在本 iframe 内导航，表现为“点击无反应”。
 * @param {Document} iframeDoc iframe 的 contentDocument
 * @param {Object} [options]
 * @param {Function} [options.shouldIgnore] 返回 true 时跳过本次点击（例如拖拽中）
 * @returns {Function} 解绑函数，调用后移除监听
 */
function bindIframeLinkClickToNewTab(iframeDoc, options = {}) {
    if (!iframeDoc || typeof iframeDoc.addEventListener !== 'function') {
        return () => {};
    }
    const {shouldIgnore} = options;
    const onIframeLinkClick = (event) => {
        if (typeof shouldIgnore === 'function' && shouldIgnore()) {
            return;
        }
        const anchor = event.target?.closest?.('a[href]');
        if (!anchor) {
            return;
        }
        const rawHref = (anchor.getAttribute('href') || '').trim();
        // 页内锚点与 javascript: 伪协议不做跳转处理
        if (!rawHref || rawHref.startsWith('#') || /^javascript:/i.test(rawHref)) {
            return;
        }
        let resolved;
        try {
            resolved = new URL(rawHref, iframeDoc.baseURI || document.baseURI);
        } catch (error) {
            return;
        }
        // 仅接管 http/https 链接，mailto、tel 等交由浏览器默认行为处理
        if (resolved.protocol !== 'http:' && resolved.protocol !== 'https:') {
            return;
        }
        event.preventDefault();
        window.open(resolved.href, '_blank', 'noopener,noreferrer');
    };
    iframeDoc.addEventListener('click', onIframeLinkClick);
    return () => {
        iframeDoc.removeEventListener('click', onIframeLinkClick);
    };
}

export {convertToHTML, convertLinksToHTML, addImgOnErrorAttribute, containsHtmlTags, bindIframeLinkClickToNewTab}
